import { toastStore } from './store';

export const notifySuccess = (message: string, timeOut?: number) => {
  toastStore.addToast(message, timeOut ?? 5000, 'success');
};

export const notifyError = (message: string, timeOut?: number) => {
  toastStore.addToast(message, timeOut ?? 5000, 'error');
};

export const notifyWarning = (message: string, timeOut?: number) => {
  toastStore.addToast(message, timeOut ?? 5000, 'warning');
};

export const notifyInfo = (message: string, timeOut?: number) => {
  toastStore.addToast(message, timeOut ?? 5000, 'info');
};

export const notifyPromiseWithProgress = async ({
  promise,
  loadingMessage,
  successMessage,
  errorMessage,
  timeOut,
  setIsLoading,
}: {
  promise: Promise<any>;
  loadingMessage: string;
  successMessage: string;
  errorMessage: string;
  timeOut?: number;
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}): Promise<any> => {
  const toastId = toastStore.addToast(loadingMessage, 100000, 'info');

  return promise
    .then((response) => {
      toastStore.updateToast(toastId, successMessage, 'success');
      setTimeout(() => toastStore.removeToast(toastId), timeOut ?? 5000);
      return response;
    })
    .catch((err) => {
      toastStore.updateToast(toastId, errorMessage, 'error');
      setTimeout(() => toastStore.removeToast(toastId), timeOut ?? 5000);
      return Promise.reject(err);
    })
    .finally(() => {
      if (setIsLoading) {
        setIsLoading(false);
      }
    });
};

export const notifyPromise = ({
  promise,
  loadingMessage,
  successMessage,
  errorMessage,
  timeOut,
}: {
  promise: Promise<any>;
  loadingMessage: string;
  successMessage: string;
  errorMessage: string;
  timeOut?: number;
}) => {
  return notifyPromiseWithProgress({
    promise,
    loadingMessage,
    successMessage,
    errorMessage,
    timeOut,
  });
};
